import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export function ClinicalGrid({ children, className = "" }: Props) {
  return (
    <div className={`grid grid-cols-1 gap-4 lg:grid-cols-2 ${className}`}>
      {children}
    </div>
  );
}

export default ClinicalGrid;
